import theme from '@/constants/theme';

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    flex: 1,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  compactHeader: {
    display: 'inline-flex',
    flexDirection: 'column',
    gap: 4,
  },
  emoji: {
    color: theme.colors.primary,
    fontSize: 60,
  },
  title: {
    color: theme.colors.text.title,
    fontSize: 24,
  },
  subtitle: {
    color: theme.colors.text.subtitle,
    fontSize: 20,
    fontWeight: 'initial',
    textWrap: 'balance',
  },
  analysisContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    color: theme.colors.text.body,
    listStyle: 'none',
    overflow: 'auto',
    flex: 1,
    maxHeight: '100%',
    backgroundColor: theme.colors.background.secondary,
    padding: 16,
    borderRadius: 16,
    position: 'relative',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    maxWidth: '240px',
    marginInline: 'auto',
    textAlign: 'center',
  },
};

export default styles;
